// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"1469":"chunk-assistant","2333":"chunk-dtg-dashboard","4071":"chunk-dtg-secondary","8218":"chunk-dtg"}[chunkId] + "." + {"1469":"31eb4be4","2333":"cf70428f","4071":"a611bfce","8218":"9a0ca3bb"}[chunkId] + ".css";
};